module.exports = __webpack_public_path__ + "static/media/computer.dffb4213.png";